/**
 * StrategyRecap — the approved Marketing Strategy embedded inline.
 *
 * Consumes the same shape produced by Sprint 3's Planner. We do NOT
 * recompute — we simply re-use the Sprint 3 section components so the
 * copy stays consistent everywhere.
 */
import { ExecutiveSummary } from "@/features/marketing-strategy/ui/sections/ExecutiveSummary";
import { CampaignHealthCard } from "@/features/marketing-strategy/ui/sections/CampaignHealthCard";
import { AllocationMatrixSection } from "@/features/marketing-strategy/ui/sections/AllocationMatrixSection";
import { PublishingCadenceSection } from "@/features/marketing-strategy/ui/sections/PublishingCadenceSection";
import { ExplainMyStrategySection } from "@/features/marketing-strategy/ui/sections/ExplainMyStrategySection";
import type { CampaignBlueprint } from "@/features/marketing-strategy/types";

export function StrategyRecap({
  blueprint,
}: {
  blueprint: CampaignBlueprint;
}): JSX.Element | null {
  if (!blueprint.strategy || !blueprint.allocation || !blueprint.cadence) {
    return null;
  }
  return (
    <section
      className="space-y-10"
      data-testid="room-strategy-recap"
    >
      <div>
        <p className="text-xs uppercase tracking-widest text-muted-foreground mb-2">
          Marketing Strategy
        </p>
        <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight mb-6">
          The approved plan
        </h2>
      </div>
      <ExecutiveSummary summary={blueprint.strategy.executive_summary} />
      <CampaignHealthCard health={blueprint.strategy.campaign_health} />
      <AllocationMatrixSection allocation={blueprint.allocation} />
      <PublishingCadenceSection cadence={blueprint.cadence} />
      <ExplainMyStrategySection items={blueprint.strategy.explain_my_strategy} />
    </section>
  );
}
